export default "__VITE_ASSET__Btov6Hwz__"